import { render, staticRenderFns } from "./DynamicNotificationDialog.vue?vue&type=template&id=057b4c6c&lang=pug&"
import script from "./DynamicNotificationDialog.vue?vue&type=script&lang=ts&"
export * from "./DynamicNotificationDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports